import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
// import appStoreImg from "./path/to/app-store.png";
// import playStoreImg from "./path/to/play-store.png";
import growwLogo from "../img/logo-blue.png";

const Footer = () => {
    return (
        <footer className=" py-5 " style={{ background: '#f7f7f7' }}>
            <Container>
                <Row className="mb-4">
                    {/* Company Info */}
                    <Col md={3} className="mb-4 mb-md-0" style={{ fontSize: '14px' }}>
                        <Image src={growwLogo} alt="Groww Logo" width={160} className="mb-3" />
                        <address className="text-muted">
                            Kochar Technology Park, 6th Floor,<br />
                            1st Cross Road, Ambattur Industrial <br />
                            Estate, Ambattur, Chennai – 600058.<br />

                        </address>
                        <div className="d-flex gap-3">
                            <a href="#"><i className="bi bi-facebook"></i></a>
                            <a href="#"><i className="bi bi-twitter"></i></a>
                            <a href="#"><i className="bi bi-instagram"></i></a>
                            <a href="#"><i className="bi bi-linkedin"></i></a>
                            <a href="#"><i className="bi bi-telegram"></i></a>
                        </div>
                    </Col>

                    {/* Products */}
                    <Col md={3} className="mb-4 mb-md-0" style={{ fontSize: '14px' }}>
                        <h5 className="fw-bold">COMPANY</h5>
                        <ul className="list-unstyled">
                            <li><a href="#" className="text-dark text-decoration-none">About</a></li>
                            <li><a href="#" className="text-dark text-decoration-none">Kosh</a></li>
                            <li><a href="#" className="text-dark text-decoration-none">IPO</a></li>
                            <li><a href="#" className="text-dark text-decoration-none">Products</a></li>
                            <li><a href="#" className="text-dark text-decoration-none">Pricing</a></li>
                            <li><a href="#" className="text-dark text-decoration-none">List of Charges</a></li>
                            <li><a href="#" className="text-dark text-decoration-none">Contact</a></li>
                        </ul>
                    </Col>

                    {/* Groww */}
                    <Col md={3} className="mb-4 mb-md-0" style={{ fontSize: '14px' }}>
                        <h5 className="fw-bold">USEFUL LINKS</h5>
                        <ul className="list-unstyled">
                            <li><a href="#" className="text-dark text-decoration-none">Brokerage Calculator</a></li>
                            <li><a href="#" className="text-dark text-decoration-none">Downloads</a></li>
                            <li><a href="#" className="text-dark text-decoration-none">Margin Calculator</a></li>
                            <li><a href="#" className="text-dark text-decoration-none">Fund Transfer</a></li>
                            <li><a href="#" className="text-dark text-decoration-none">Knowledge Center</a></li>
                            <li><a href="#" className="text-dark text-decoration-none">Refer & Earn</a></li>
                            <li><a href="#" className="text-dark text-decoration-none">Algo Trading</a></li>
                            <li><a href="#" className="text-dark text-decoration-none">Investor Charter</a></li>
                        </ul>
                    </Col>

                    {/* Quick Links */}
                    <Col md={3} className="mb-4 mb-md-0" style={{ fontSize: '14px' }}>
                        <h5 className="fw-bold">QUICK CONTACT</h5>
                        <p className="m-0">Support Number:</p>
                        <p className="m-0">044-61329696</p>
                        <p className="m-0">Support Email:</p>
                        <p className="m-0">support@flattrade.in</p>
                    </Col>
                </Row>

                <Row className="mt-4">
                    <Col md={6} style={{ fontSize: '14px' }}>
                        <p className="text-muted mb-0">
                            © 2025. FLATTRADE is online brand of{" "}
                            <span className="text-danger"></span> Fortune Capital Services P Ltd.
                        </p>
                    </Col>
                    <Col md={6} className="d-flex justify-content-md-end">
                        <a href="#" className="me-3">
                            {/* <Image src={appStoreImg} alt="App Store" width="120" /> */}
                        </a>
                        <a href="#">
                            {/* <Image src={playStoreImg} alt="Google Play Store" width="120" /> */}
                        </a>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
